// extracted by mini-css-extract-plugin
export var tipDate = "tip-date-module--tip-date--6phip";
export var tipDateItem = "tip-date-module--tip-date-item--PF3HB";
export var tipPostDateResponsiveComma = "tip-date-module--tip-post-date-responsive-comma--U3aKj";
export var rssDecoration = "tip-date-module--rss-decoration--F0L+D";
export var rssDecorationContainer = "tip-date-module--rss-decoration-container--qK4-E";
export var tipHeaderDecorationContainer = "tip-date-module--tip-header-decoration-container--98M9N";